<template>
  <div class="page-content dashboard">
    <div class="page-title">
      <span>{{ $lang.messages.dashboard.toUpperCase() }}</span>
    </div>
    <div class="page-wrapper-reports">
      <section class="box-area">
        <div class="box balance">
          <div class="box-inner background">
            <div class="box-data" v-if="payLoaded">
              <p class="data-title uppercase-text">{{ $lang.messages.toPay }}</p>
              <p class="you-owe-amount" >
                <currency-sign :currency="currency"></currency-sign>
                <ICountUp
                  :delay="delay"
                  :endVal="toPay"
                  :options="options[0]" />
              </p>
            </div>
            <span class="vertical-line" v-if="payLoaded"></span>
            <div class="box-data" v-if="payLoaded">
              <p class="data-title uppercase-text">{{ $lang.messages.toReceive }}</p>
              <p class="you-are-owed-amount">
                <currency-sign :currency="currency"></currency-sign>
                <ICountUp
                  :delay="delay"
                  :endVal="toRecieve"
                  :options="options[1]" />
              </p>
            </div>
          </div>
        </div>

        <div class="box conversations" v-if="checkUnreadMessages()">
          <div class="box-title">
            {{ $lang.messages.newMessagesTitle }}
            <span class="box-name-info" @click="messagesTooltip = true" :class="{ 'blue-box-info': messagesTooltip}"></span>
            <f-p-tooltip
              v-if="messagesTooltip"
              v-click-outside="hideMessagesTooltip"
              :hideTooltipInside="hideMessagesTooltip"
              :tooltipTitle="$lang.messages.tp_dashboardMessageCenterTitle"
              :tooltipContent="$lang.messages.tp_dashboardMessageCenterText"
              :tooltipHasLink="'MessageCenter'"
              :tooltipHasLinkText="$lang.messages.tp_dashboardMessageCenterTitle">
            </f-p-tooltip>
          </div>
          <div class="list">
            <div
              class="item"
              v-for="conversation in conversationsList"
              :key="conversation.conversationGuid"
              v-show="conversation.unreadMessageCount"
              @click="handleDashMessageClick(conversation.conversationGuid)"
            >
              <div class="item-data">
                <div class="sender">
                  <div>
                    {{ conversation.firstName.substring(0, 1) }}
                    {{ conversation.lastName.substring(0, 1) }}
                  </div>
                  <p>{{ conversation.firstName }} {{ conversation.lastName.substring(0, 1) }}.</p>
                </div>
                <span class="vertical-line"></span>
                <div class="message">
                  <div class="time">{{ formatDate(conversation.lastMessageTimestamp) }}</div>
                  <div class="text">{{ conversation.lastMessagePreview }}</div>
                  <div class="more-unread" v-if="conversation.unreadMessageCount - 1 >= 1">
                    + {{ conversation.unreadMessageCount - 1 }}
                    {{ $lang.messages.moreMsg }}
                    <span v-if="conversation.unreadMessageCount - 1 > 1">s</span>
                    {{ $lang.messages.fromThisUser }}
                  </div>
                </div>
                 <div class="close">
                   <div @click="closeConversation($event, conversation.conversationGuid)">
                     <img src="@/assets/images/close_ico.png" class="close-ico" />
                     <img src="@/assets/images/close_ico_active.png" class="close-ico-active" />
                   </div>
                 </div>
              </div>
            </div>
          </div>
        </div>
        <div class="box no-msg-wrapper" v-else>
          <img src="@/assets/images/no-msg-dashboard.png" alt="No messages" class="img-fuild">
          <p>
            <strong>{{ $lang.messages.noMsgDashboard }}</strong>
          </p>
          <p>
            {{ $lang.messages.noMsgDashboardPara }}.
          </p>
        </div>
      </section>

      <section class="box-area">
        <div class="box events-expenses">
          <div class="box-title" :class="{ 'tabs-dash-border': expensesList.length || eventsList.length }">
            {{ $lang.messages.timeline }}
            <span class="box-name-info" @click="timelineTooltip = true" :class="{ 'blue-box-info': timelineTooltip }"></span>
            <f-p-tooltip
              v-if="timelineTooltip"
              v-click-outside="hideTimelineTooltip"
              :hideTooltipInside="hideTimelineTooltip"
              :tooltipTitle="$lang.messages.tp_dashboardTimelineTitle"
              :tooltipContent="$lang.messages.tp_dashboardTimelineText">
            </f-p-tooltip>
            <div class="tabs" v-show="expensesList.length || eventsList.length">
              <div class="tab" @click="chooseExpenses" v-show="expensesList.length">
                <img src="@/assets/images/expenses_tab_ico.png" />
                {{ $lang.messages.payments }}
                <div class="marker" :class="{'active' : expensesActive}"></div>
              </div>
              <div class="tab" @click="chooseEvents" v-show="eventsList.length">
                <img src="@/assets/images/events_tab_ico.png" />
                {{ $lang.messages.events }}
                <div class="marker" :class="{'active' : eventsActive}"></div>
              </div>
            </div>
          </div>

          <!-- TIMELINE PAYMENTS-->
          <template v-if="expensesList.length && expensesActive">
            <div class="expenses-wrapper" @scroll="scrollExpenses">
              <div class="expenses-container">
                <div class="list">
                  <div class="skeleton-screen" v-show="loading" v-for="(i) of loadingArray">
                    <div></div>
                  </div>
                  <div
                    v-for="(date, dateIndex) in expensesList"
                    :key="`dashDateIndex-${dateIndex}`"
                    class="item"
                    :class="{'same-as-previous': isDateSameAsPrevious(date)}"
                    v-show="!loading"
                  >
                    <div class="separator" v-if="showYearSeparator(date, dateIndex)">
                      <img src="@/assets/images/events_tab_ico.png" />
                      {{ date.date.split('-')[0] }}
                    </div>
                    <div class="item-content">
                      <div class="date" :class="{'today' : isToday(date.date)}">
                        <span v-show="!isDateSameAsPrevious(date)">{{ formatDateEventsPayments(date.date) }}</span>
                      </div>
                      <div class="items-list">
                        <div
                          v-for="expense in date.dashboardExpenseDetailsDtos"
                          :key="expense.guid"
                          @click="handleDashPayClick(expense.expenseType, expense.guid, expense.paymentStatus)"
                        >
                          <div class="single-type">
                            <img src="@/assets/images/expense_ico.png" />
                            <p class="summary">{{ expense.summary}}</p>
                            <div class="status">
                              <p>
                                <currency-sign :currency="expense.currency"></currency-sign>
                                {{ currencyFormat(expense.amount) }}
                              </p>
                              <label
                                class="lbl"
                                :class="
                                expense.paymentStatus === 'NOT_PAID' ?
                                'lbl-unpaid' : expense.paymentStatus === 'PAID' ||
                                expense.paymentStatus === 'PAID_EXTERNALLY' || expense.paymentStatus === 'DIGITAL_CHECK' ?
                                'lbl-paid' : expense.paymentStatus === 'PENDING' ?
                                'lbl-pending': 'lbl-rejected'
                              ">
                                {{
                                  expense.paymentStatus === 'NOT_PAID' ? $lang.messages.notPaid :
                                  expense.paymentStatus === 'PENDING' ? $lang.messages.pending :
                                  expense.paymentStatus === 'REJECTED' ? $lang.messages.rejected :
                                  expense.paymentStatus === 'DIGITAL_CHECK' ? '🗸 ' + $lang.messages.digitalCheck :
                                  expense.paymentStatus === 'PAID_EXTERNALLY' ? '🗸 ' + $lang.messages.paidExternally:
                                  '🗸 ' + $lang.messages.paid
                                }}
                              </label>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </template>
          <!-- TIMELINE EVENTS-->
          <template v-if="eventsList.length && eventsActive">
            <div class="events-wrapper" @scroll="scrollEvents">
              <div class="events-container">
                <div class="list">
                  <div
                    class="item"
                    v-for="(date, dateIndex) in eventsList"
                    :key="`dashEventList-${dateIndex}`"
                    @click="handleDashEventClick(date)"
                  >
                    <div class="separator" v-if="showYearSeparator(date, dateIndex)">
                      <img src="@/assets/images/events_tab_ico.png" />
                      {{ date.startDate.split('-')[0] }}
                    </div>
                    <div class="item-content">
                      <div class="date" :class="{'today' : isToday(date.startDate)}">
                        {{ formatDateEventsPayments(date.startDate) }}
                      </div>
                      <div class="items-list">
                        <div
                            v-for="(event, eventIndex) in date.events"
                            :key="`dashDateEventList-${eventIndex}`"
                        >
                          <div class="single-type event-type" v-if="event.type === 'DASHBOARD_EVENT'">
                            <img src="@/assets/images/reminder_ico.png" />
                            <p>{{ event.summary}}</p>
                          </div>
                          <div class="single-type visitation-type" v-if="event.type === 'DASHBOARD_CHILD_VISITIATION'">
                            <span :style="{backgroundColor: event.color ? event.color : ''}"></span>
                            <p>{{ event.summary}}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </template>
          <template v-if="!expensesList.length && !eventsList.length">
            <div class="timeline-dashboard">
              <img src="@/assets/images/timeline-dashboard.png" alt="Calendar" class="img-fluid">
              <p>
                <strong>{{ $lang.messages.noTimelineInfo }}</strong>
              </p>
              <p>
                {{ $lang.messages.noTimelineInfoPara }}
              </p>
            </div>
          </template>
        </div>
      </section>
    </div>
    <transactions-suspended-notice-modal  ref="transactionsSuspendedNoticeComponent" />
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { GET_DASHBOARD_EVENTS, GET_DASHBOARD_EXPENSES, GET_REGISTRATION_PROGRESS } from '@/store/action.types';
import CurrencySign from "@/components/common/CurrencySign";
import vClickOutside from 'v-click-outside'
import ICountUp from 'vue-countup-v2';
import { format, parseISO } from 'date-fns'
import { currencyFormat } from "@/mixins/currencyFormat";
import { WS_CLOSE_CONVERSATION_SEND } from '@/constants/ApiConstants';
import TransactionsSuspendedNoticeModal from "@/components/appLayout/TransactionsSuspendedNoticeModal";
import STATUS_CODES from "@/common/statusCodes";

export default {
  name: "dashboard",
  components: {
    'f-p-tooltip': () => import('@/components/common/FPTooltip'),
    CurrencySign,
    ICountUp,
    TransactionsSuspendedNoticeModal
  },
  mixins: [
    currencyFormat
  ],
  directives: {
    clickOutside: vClickOutside.directive
  },
  data() {
    return {
      currency: this.$store.getters.currency,
      toPay: 0,
      toRecieve: 0,
      delay: 0,
      options: [{
        startVal: 0,
        useEasing: true,
        useGrouping: true,
        separator: ',',
        decimal: '.',
        prefix: '',
        suffix: '',
        decimalPlaces: 2
      },{
          startVal: 0,
          useEasing: true,
          useGrouping: true,
          separator: ',',
          decimal: '.',
          prefix: '',
          suffix: '',
          decimalPlaces: 2
      }],
      pageEvents: 0,
      sizeEvents: 6,
      eventsList: [],
      scrollerPositionDownEvents: false,
      expensesActive: true,
      eventsActive: false,
      pageExpenses: 0,
      sizeExpenses: 6,
      expensesList: [],
      scrollerPositionDownExpenses: false,
      dateFormat: 'MMM d',
      messagesTooltip: false,
      timelineTooltip: false,
      payLoaded: false,
      loading: true,
      loadingArray: [{}, {}],
      conversationsList: [],
    };
  },
  computed: {
    ...mapGetters(["coparentGuid", "transactionsSuspended", "isAppLocked"])
  },
  mounted() {
    if (this.transactionsSuspended && !this.isAppLocked) {
      this.$refs.transactionsSuspendedNoticeComponent.show();
    }
    this.getRegistrationProgressAction();
    this.loadExpenses();
    this.loadEvents();
    this.conversationsList = this.$store.getters.getConversationsList;
    this.$root.$on('conversations', this.conversationsUpdated);
  },
  methods: {
    ...mapActions({
      getEvents: GET_DASHBOARD_EVENTS,
      getExpenses: GET_DASHBOARD_EXPENSES,
      getRegistrationProgressAction: GET_REGISTRATION_PROGRESS
    }),
    conversationsUpdated(conversations) {
      this.conversationsList = conversations;
      this.$forceUpdate();
    },
    formatDateEventsPayments(date) {
      if (date) {
        if (typeof date === 'string') {
          return format(parseISO(date), this.dateFormat)
        }
        return format(date, this.dateFormat)
      }
    },
    closeConversation(event, guid) {
      event.stopPropagation();
      this.$parent.stompClient.send(WS_CLOSE_CONVERSATION_SEND.replace(":coparentGuid", this.coparentGuid).replace(":conversationGuid", guid));
    },
    loadExpenses() {
      this.loading = true;
      let data = {
        page: 0,
        size: this.sizeExpenses
      }
      this.getExpenses(data)
      .then(response => {
        this.toPay = response.data.data.toPay;
        this.toRecieve = response.data.data.toRecieve;
        this.expensesList = response.data.data.dashboardExpenseDtos;
        this.options[0].startVal = Math.max((response.data.data.toPay - 75.00), 0);
        this.options[1].startVal = Math.max((response.data.data.toRecieve - 75.00), 0);
        this.payLoaded = true;
      })
      .catch(error => {
        if (error.response.status !== 406 && error.response.data.status.code !== STATUS_CODES.FP_405 && error.response.status !== 401 && error.response.status !== 402) {
          this.$snotify.error('Something went wrong.', 'ERROR');
        }
      })
      .finally(() => this.loading = false);
    },
    loadExpensesOnScroll() {
      let data = {
        page: this.pageExpenses,
        size: this.sizeExpenses
      }
      this.getExpenses(data)
      .then(response => {
        response.data.data.dashboardExpenseDtos.forEach(event => {
          this.expensesList.push(event)
        })
      })
      .catch(error => {
        if (error.response.status !== 406 && error.response.data.status.code !== STATUS_CODES.FP_405 && error.response.status !== 401 && error.response.status !== 402) {
          this.$snotify.error('Something went wrong.', 'ERROR');
        }
      });
    },
    scrollExpenses(expense) {
      if (this.expensesActive) {
        let wrapper = document.querySelector('.expenses-wrapper')
        let container = document.querySelector('.expenses-container')

        if (wrapper && container) {
          if (wrapper.getBoundingClientRect().bottom + 10 >= container.getBoundingClientRect().bottom) {
            this.scrollerPositionDownExpenses = true
          } else {
            this.scrollerPositionDownExpenses = false
          }
        }

        if ((expense.target.scrollTop + expense.target.offsetHeight) >= expense.target.scrollHeight) {
          let neededPage = 0
          if (this.scrollerPositionDownExpenses) {
            neededPage = this.pageExpenses + 1
          }
          this.pageExpenses = neededPage

          this.loadExpensesOnScroll()
        }
      }
    },
    loadEvents() {
      let data = {
        page: this.pageEvents,
        size: this.sizeEvents
      };
      this.getEvents(data)
      .then(response => {
        this.eventsList = response.data.data;
        this.setInitTabs()
      })
      .catch(error => {
        if (error.response.status !== 406 && error.response.data.status.code !== STATUS_CODES.FP_405 && error.response.status !== 401 && error.response.status !== 402) {
          this.$snotify.error('Something went wrong.', 'ERROR');
        }
      });
    },
    loadEventsOnScroll() {
      let data = {
        page: this.pageEvents,
        size: this.sizeEvents
      }
      this.getEvents(data)
      .then(response => {
        response.data.data.forEach(event => {
          this.eventsList.push(event)
        })
      })
      .catch(error => {
        if (error.response.status !== 406 && error.response.data.status.code !== STATUS_CODES.FP_405 && error.response.status !== 401 && error.response.status !== 402) {
          this.$snotify.error('Something went wrong.', 'ERROR');
        }
      });
    },
    scrollEvents(event) {
      if(this.eventsActive) {
        let wrapper = document.querySelector('.events-wrapper')
        let container = document.querySelector('.events-container')

        if (wrapper && container) {
          if (wrapper.getBoundingClientRect().bottom + 10 >= container.getBoundingClientRect().bottom) {
            this.scrollerPositionDownEvents = true
          } else {
            this.scrollerPositionDownEvents = false
          }
        }

        if ((event.target.scrollTop + event.target.offsetHeight + 1) >= event.target.scrollHeight) {
          let neededPage = 0
          if (this.scrollerPositionDownEvents) {
            neededPage = this.pageEvents + 1
          }
          this.pageEvents = neededPage

          this.loadEventsOnScroll()
        }
      }
    },
    setInitTabs () {
      if ((this.expensesList.length && this.eventsList.length) || (this.expensesList.length && !this.eventsList.length)) {
        this.expensesActive = true;
        this.eventsActive = false;
      } else if (!this.expensesList.length && this.eventsList.length) {
        this.expensesActive = false;
        this.eventsActive = true;
      }
    },
    formatDate(date) {
      date = new Date(date);
      const dateFormat = this.$store.getters.dateFormat;
      const now = Date.now();

      const delta = Math.round((now - date) / 1000);

      const minute = 60;
      const hour = minute * 60;
      const day = hour * 24;
      const week = day * 7;

      if (delta < 30) {
        return 'Just now...'
      }
      else if (delta < minute) {
        return delta + ' seconds ago'
      }
      else if (delta < 2 * minute) {
        return 'A minute ago'
      }
      else if (delta < hour) {
        return Math.floor(delta / minute) + ' minutes ago'
      }
      else if (Math.floor(delta / hour) === 1) {
        return '1 hour ago'
      }
      else if (delta < day) {
        return Math.floor(delta / hour) + ' hours ago'
      }
      else if (delta < day * 2) {
        return 'Yesterday'
      }
      else if (delta < week) {
        return Math.floor(delta / week) + ' days ago'
      }
      else if (delta < week * 2) {
        return 'A week ago'
      }
      else {
        return format(date, dateFormat);
      }
    },
    isToday(dateParam) {
      let today = new Date()
      let date = new Date(dateParam)
      return date.getDate() === today.getDate() && date.getMonth() === today.getMonth() && date.getFullYear() === today.getFullYear()
    },
    chooseEvents() {
      this.eventsActive = true
      this.expensesActive = false
    },
    chooseExpenses() {
      this.expensesActive = true
      this.eventsActive = false
    },
    isDateSameAsPrevious(date) {
      let sameAsPrevious = false
      let currentIndex = this.expensesList.indexOf(date)
      let previousDate = null
      if (this.expensesList[currentIndex-1]) {
        previousDate = this.expensesList[currentIndex-1]
      }

      if (previousDate) {
        if (format(parseISO(date.date), 'dd') === format(parseISO(previousDate.date), 'dd') && format(parseISO(date.date), 'MMM') === format(parseISO(previousDate.date), 'MMM')) {
          sameAsPrevious = true
        }
      }

      return sameAsPrevious
    },
    handleDashPayClick(routeVal, routeParam, expenseStatus) {
      this.$router.push({ name: this.computedRoute(routeVal), params: { id: routeParam, expenseStatus: expenseStatus } })
    },
    computedRoute(expenseType) {
      return (
          expenseType === this.$ALIMONY_EXPENSE_TYPE ?
          'ExpenseDetailsSpousalMaintenance' : expenseType === this.$CHILD_EXPENSE_TYPE ?
          'ExpenseDetailsChildMaintenance' : 'ExpenseDetailsSharedExpenses'
      );
    },
    handleDashMessageClick(routeParam) {
      this.$router.push({ name: 'MessageCenter', params: { guid: routeParam } })
    },
    hideMessagesTooltip(e) {
      e.stopPropagation();
      this.messagesTooltip = false;
    },
    hideTimelineTooltip(e) {
      e.stopPropagation();
      this.timelineTooltip = false;
    },
    checkUnreadMessages() {
      return this.conversationsList.filter(elem => {
        return elem.unreadMessageCount
      }).length;
    },
    handleDashEventClick(event) {
      this.$router.push({ name: 'Calendar', params: { date: event.startDate } })
    },
    showYearSeparator(item, index) {
      if (index > 0) {
        let itemYear = item.date ? item.date.split('-')[0].toString() : item.startDate.split('-')[0].toString();
        let previousItemYear = item.date ? this.expensesList[index - 1].date.split('-')[0].toString() : this.eventsList[index - 1].startDate.split('-')[0].toString();
        if (itemYear !== previousItemYear) {
          return true;
        }
      } else {
        return false

      }
    }
  }
};
</script>
